(function(){
  let loading = false
  let info_expand = false
  function init(){
    $(".input_form a.t4s-btn").click(async function(e){
      e.preventDefault();
      submit()
    })
  }
  async function submit(){
    // 用ajax获取api数据，并处理404等出错情况
    // $(".t4s-custom-liquid").hide(0)
    const email = $('.input_form_content input#email').val()
    const state = $('.input_form_content input#state').val()
    const url = $('.input_form_content textarea#url').val()
    let pass = true
    let error = ''
    if(!email || !isValidEmail(email)){
      error += 'Please enter a valid email address.\n'
      pass = false
    }
    if(!url || !isValidUrl(url)){
      error += 'Please enter a valid url.\n'
      pass = false
    }
    if(!pass){
      alert(error)
      return
    }
    const data = {
      email,
      state,
      link: url,
    }
    await $.ajax({
      url: `https://ecowrd.com/webhook/kol-collection/create/`,
      method: 'POST',
      data,
      success: function(data,status,xhr){
        $('.input_form_content input#email').val('')
        $('.input_form_content input#state').val('')
        $('.input_form_content textarea#url').val('')
        alert('Submit Success, thank you!')
      },
      error: function(xhr,status,error){
        alert(xhr.responseJSON.message)
      }
    })
  }
  function isValidEmail(email) {
    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRegex.test(email);
  }
  function isValidUrl(url) {
    const urlRegex = /^(http|https):\/\/[^ "]+$/;
    return urlRegex.test(url);
  }
  MB_jsDeferHandle(init, ['jQuery'])
}) ()